import {Children, ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import PictureThumbnail from './PictureThumbnail';
import PictureListState from '../states/PictureListState';

const translationPrefix = 'kilowhat-cimaise.forum.picture-list.';

interface PictureListAttrs {
    state: PictureListState
    thumbnailAttrs: any
}

export default class PictureList implements ClassComponent<PictureListAttrs> {
    view(vnode: Vnode<PictureListAttrs>) {
        const {state} = vnode.attrs;

        let loading: Children;

        if (state.loading) {
            loading = LoadingIndicator.component();
        } else if (state.moreResults) {
            loading = Button.component({
                className: 'Button',
                onclick: state.loadMore.bind(state),
            }, app.translator.trans(translationPrefix + 'load-more'));
        }

        if (state.pictures.length === 0 && !state.loading) {
            return Placeholder.component({
                text: app.translator.trans(translationPrefix + 'empty'),
            });
        }

        return m('div', [
            m('.AlbumPictureList', state.pictures.map(picture => m(PictureThumbnail, {
                picture,
                ondelete: () => {
                    state.removePicture(picture);
                },
                ...vnode.attrs.thumbnailAttrs,
            }))),
            loading,
        ]);
    }
}
